export function shouldRegisterPwa(
  isProduction: boolean,
  browserNavigator: object | undefined,
): boolean {
  return (
    isProduction &&
    browserNavigator !== undefined &&
    "serviceWorker" in browserNavigator
  );
}
